import { useView } from "features/view/context/ViewContext";
import { useHistory } from "react-router-dom";
import Pager from "components/ui/Pager/Pager";

const ViewPager = () => {
  const { view, isLoading } = useView();
  const history = useHistory();

  if (!view || !view?.pager?.total_pages || view.pager.total_pages < 2 || isLoading) {
    return null;
  }

  const handlePageChange = (page) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', page);
    history.push('?' + searchParams.toString());
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  const pageCount = view.pager.total_pages;
  const currentPage = view.pager.current_page + 1;

  return (
    <Pager currentPage={ currentPage } totalPages={ pageCount } onChange={ handlePageChange } />
  )
}

export default ViewPager;
